import NotReportableException from '@/exceptions/NotReportableException'
import RequestException from '@/exceptions/RequestException'
import UserActivityException from '@/exceptions/UserActivityException'
import { serverUrl } from '@/globals/env'
import { useAuthStore } from '@/stores/auth'
import * as Sentry from '@sentry/vue'

export const cancelApi = async () => {
  const authStore = useAuthStore()
  try {
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'content-type': 'application/json',
        Authorization: 'Bearer ' + authStore.user.token
      }
    }

    let response = await fetch(serverUrl + 'cancel-subscription', options)

    //refresh token if it has expired
    if (response.status === 419) {
      await authStore.refreshToken()
      options.headers['Authorization'] = 'Bearer ' + authStore.user.token
      response = await fetch(serverUrl + 'cancel-subscription', options)
    } else if (response.status === 401) {
      //logout user and return
      await authStore.destroyUserData()
      return { status: response.status, json: { message: 'invalid session' } }
    }

    if (!response.ok) {
      throw new Error(
        `Your subscription may have already been canceled. Reach out to our customer support if you continue having an issue.`
      )
    }

    const status = response.status
    const json = await response.json()
    return { status, json }
  } catch (err) {
    if (
      !(
        err instanceof UserActivityException ||
        err instanceof NotReportableException ||
        err instanceof RequestException
      )
    ) {
      Sentry.captureException(err)
    }
    throw new UserActivityException(`Failed to cancel subscription: ${err}`)
  }
}
